import { PiMoneyWavyLight } from "react-icons/pi";
import { FaRegCreditCard } from "react-icons/fa6";
import { BsCreditCard } from "react-icons/bs";
import { RiCoinsFill } from "react-icons/ri";
import { PiLinkSimpleBold } from "react-icons/pi";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";

export const PaymentMethods = [
    {
        name: "Cash",
        icon: <PiMoneyWavyLight/>,
        value:'cash',
    },
    {
        name: "Debit Card",
        icon: <FaRegCreditCard/>,
        value: 'debit_card',
    },
    {
        name: "Credit Card",
        icon: <BsCreditCard/>,
        value: 'credit_card',
    },
    {
        name: "Store Credit",
        icon: <RiCoinsFill/>,
        value: 'credit',
    },
    {
        name: "Payment Links",
        icon: <PiLinkSimpleBold/>,
        value: 'payment_links',
    },
    {
        name: "Others",
        icon: <HiOutlineDotsCircleHorizontal/>,
        value: 'others',
    },
];